import moment from 'moment';

import {
  IContractCancellationTracking,
  TContractCancellationStatus,
} from 'modules/customer/domain/entities';

type TVectisContractCancellationStatus =
  | 'PEDIDO_RECEBIDO_EM_ANALISE'
  | 'AGUARDANDO_ASSINATURA'
  | 'LINK_ASSINATURA_EXPIRADO'
  | 'CANCELAMENTO_CONCLUIDO'
  | 'CANCELAMENTO_NAO_APROVADO'
  | 'CANCELAMENTO_ENCERRADO_SEM_EFEITO';

export interface IVectisContractCancellationTracking {
  idCancelamentoContrato: number;
  cdContrato: number;
  status: TVectisContractCancellationStatus;
  descricaoStatus: string;
  dataSolicitacao: string | null;
  dataExpiracaoProposta: string | null;
  podeSolicitarNovoLink: boolean;
  podeAssinar: boolean;
  linkAssinatura: string | null;
}

const STATUS_DICTIONARY: Record<
  TVectisContractCancellationStatus,
  TContractCancellationStatus
> = {
  PEDIDO_RECEBIDO_EM_ANALISE: 'UNDER_REVIEW',
  AGUARDANDO_ASSINATURA: 'AWAITING_SIGNATURE',
  LINK_ASSINATURA_EXPIRADO: 'SIGNATURE_LINK_EXPIRED',
  CANCELAMENTO_CONCLUIDO: 'COMPLETED',
  CANCELAMENTO_NAO_APROVADO: 'NOT_APPROVED',
  CANCELAMENTO_ENCERRADO_SEM_EFEITO: 'CLOSED_WITHOUT_EFFECT',
};

const DEFAULT_STATUS: TContractCancellationStatus = 'UNDER_REVIEW';

export const parseVectisDate = (value?: string | null): Date | null => {
  if (!value) return null;

  const date = moment(value, moment.ISO_8601);

  return date.isValid() ? date.toDate() : null;
};

export class ContractCancellationTracking
  implements IContractCancellationTracking
{
  public id: IContractCancellationTracking['id'];
  public contractCode: IContractCancellationTracking['contractCode'];
  public status: IContractCancellationTracking['status'];
  public statusDescription: IContractCancellationTracking['statusDescription'];
  public requestedAt: IContractCancellationTracking['requestedAt'];
  public proposalExpiresAt: IContractCancellationTracking['proposalExpiresAt'];
  public canRequestNewLink: IContractCancellationTracking['canRequestNewLink'];
  public canSign: IContractCancellationTracking['canSign'];
  public signatureLink: IContractCancellationTracking['signatureLink'];

  constructor({
    idCancelamentoContrato,
    cdContrato,
    status,
    descricaoStatus,
    dataSolicitacao,
    dataExpiracaoProposta,
    podeSolicitarNovoLink,
    podeAssinar,
    linkAssinatura,
  }: IVectisContractCancellationTracking) {
    this.id = idCancelamentoContrato;
    this.contractCode = cdContrato;
    this.status = STATUS_DICTIONARY[status] ?? DEFAULT_STATUS;
    this.statusDescription = descricaoStatus;
    this.requestedAt = parseVectisDate(dataSolicitacao);
    this.proposalExpiresAt = parseVectisDate(dataExpiracaoProposta);
    this.canRequestNewLink = !!podeSolicitarNovoLink;
    this.canSign = !!podeAssinar;
    this.signatureLink = linkAssinatura || null;
  }

  public static fromResponse(
    response: IVectisContractCancellationTracking | '' | null | undefined,
  ): IContractCancellationTracking | null {
    if (!response) return null;

    return new ContractCancellationTracking(response);
  }
}
